<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<p-table #pt [value]="realEstates" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="realEstateId" selectionMode="single"
  [(selection)]="realEstate" [loading]="loading" [paginator]="showPagination" [rows]="25"
  [rowsPerPageOptions]="[25,100,200]" showCurrentPageReport="true"
  currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
  sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
  [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

  <ng-template pTemplate="caption">
    <div class="d-block text-end justify-content-between align-items-center">
      <h1 style="float: left;margin: 6px;">Real Estates</h1>
      <span>
        <!--clear filters-->
        @if (showFilter) {
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>
        }

        <!--add new
        <button *ngIf="!outlineNewButton" pButton pRipple class="p-button-outlined" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New RealEstate +</button>
        <button *ngIf="outlineNewButton" pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
        (click)="onOpenFormAdd()">New RealEstate +</button>
        -->
      </span>
    </div>
  </ng-template>
  <ng-template pTemplate="header">
    <tr>
      @for (col of columns; track col) {
        <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
          {{col.header}}
          <p-sortIcon [field]="col.field" ></p-sortIcon>
        </th>
      }
      <th>Action</th>
      <th [ngStyle]="{'width': 'auto'}"></th>
    </tr>
    @if (showFilter) {
      <tr>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'mlsAllId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'mlsNumber', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'kbmPropertyType', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'createDate', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'lastUpdate', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'listingPrice', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'statusDesc', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [ngStyle]="{'width':'50px','min-width':'100%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'addressZip', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
      </tr>
    }
  </ng-template>
  <ng-template pTemplate="body" let-realEstate>
    <tr [pSelectableRow]="realEstate">
      <td>{{realEstate.mlsAllId}} </td>
      <td>{{realEstate.mlsNumber}} </td>
      <td><img width="80px" height="auto" [src]="getImageURL(realEstate)"></td>
      <td>{{realEstate.kbmPropertyType}} </td>
      <td>{{realEstate.createDate}} </td>
      <td>{{realEstate.lastUpdate}} </td>

      <td>{{formatCurrency(realEstate.listingPrice)}} </td>
      <td>{{realEstate.statusDesc}}</td>
      <td>{{realEstate.addressZip}}</td>
      <td>
        <span style="float:none">
          <p-dropdown class="w-100" [options]="propertyOptions" optionLabel="name"
          (onChange)="onActionSelection($event, realEstate)" optionValue="value" appendTo="body" placeholder="Select option" ></p-dropdown>
        </span>
      </td>
      <td><span style="float:none">

      </span>
    </td>
  </tr>
</ng-template>
</p-table>
